import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { track } from "@/lib/analytics";

const CTA_HREF = "https://crayo.ai";

export default function CalcCtaBand() {
  return (
    <section className="bg-[#2A66FF]">
      <div className="mx-auto w-full max-w-screen-xl px-5 py-16 text-center sm:px-6 md:px-12 md:py-20 lg:px-20">
        <h2 className="mx-auto max-w-[760px] text-balance text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-[44px] lg:leading-[1.1]">
          Seeing the numbers is step one. Posting them is step two.
        </h2>
        <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.6] text-white/80 sm:text-[17px]">
          Crayo turns one long video into a batch of ready-to-post shorts, so the view counts on
          this page become a posting schedule you can actually keep.
        </p>
        <Link
          href={CTA_HREF}
          onClick={() => track("cta_clicked", { cta: "calculator", href: CTA_HREF })}
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-[14px] font-semibold text-[#2A66FF] transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
        >
          Start clipping with Crayo
          <ArrowRight className="size-4" strokeWidth={2.25} aria-hidden />
        </Link>
      </div>
    </section>
  );
}
